module.exports = __webpack_public_path__ + "img/013.6dc29950.jpg";